import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/services/api";

export const getNotifications = createAsyncThunk(
    "notification/getNotifications",
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.get(`/admin/list-notifications?page=${data?.page}`);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to get notifications.");
        }
    }
);

export const deleteNotification = createAsyncThunk(
    "notification/deleteNotification",
    async (ids, { rejectWithValue }) => {
        try {
            const response = await api.post(`admin/delete-notifications`, {ids});
            return response;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to delete notification.");
        }
    }
);

export const readNotification = createAsyncThunk(
    "notification/readNotification",
    async (data, { rejectWithValue }) => {
        try {
            const response = await api.post(`admin/mark-notifications-read`, data);
            return response;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to read notification.");
        }
    }
);

    export const deleteAllNotifications = createAsyncThunk(
        "notification/deleteAllNotifications",
        async (_, { rejectWithValue }) => {
            try {
            const response = await api.post(`delete-all-notifications`);
            return response.data;
            } catch (err) {
            return rejectWithValue(
                err.response?.data || "Failed to delete all notifications."
            );
            }
        }
    );

    const notificationSlice = createSlice({
        name: "notification",
        initialState: {
            notifications: [],
            loading: false,
            hasMore: true,
            pending_delete_ids:[],
        },
        reducers: {
            resetStatus(state) {
                state.loading = false;
            },
            markForDelete: (state, action) => {
                const id = action.payload;
                const currentPendingIds = Array.isArray(state.pending_delete_ids)
                    ? state.pending_delete_ids
                    : [];

                state.pending_delete_ids = [...currentPendingIds, id];
                state.notifications.notifications =
                    state.notifications.notifications.filter(n => n.id !== id);
            },
        clearPendingDeletes: (state) => {
            state.pending_delete_ids = [];
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getNotifications.pending, (state) => {
                state.loading = true;
            })
            .addCase(getNotifications.fulfilled, (state, action) => {
                state.loading = false;

                const { pagination, notifications } = action.payload;

                if (pagination?.current_page === 1) {
                    state.notifications = action.payload;
                }else {
                    state.notifications.notifications = [
                        ...(state.notifications.notifications || []),
                        ...(notifications || [])
                    ];
                }
                if (pagination?.current_page >= pagination?.last_pages) {
                    state.hasMore = false;
                } else {
                    state.hasMore = true;
                }
            })

            .addCase(getNotifications.rejected, (state) => {
                state.loading = false;
            })
            .addCase(deleteNotification.pending, (state) => {
                state.loading = true;
            })
            .addCase(deleteNotification.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(deleteNotification.rejected, (state) => {
                state.loading = false;
            })
            .addCase(readNotification.pending, (state) => {
                state.loading = true;
            })
            .addCase(readNotification.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(readNotification.rejected, (state) => {
                state.loading = false;
            })
            .addCase(deleteAllNotifications.pending, (state) => {
                state.loading = true;
            })
            .addCase(deleteAllNotifications.fulfilled, (state) => {
                state.loading = false;
                state.notifications = []; 
            })
            .addCase(deleteAllNotifications.rejected, (state) => {
                state.loading = false;
            });
    },
});

export const { markForDelete, clearPendingDeletes, resetStatus } = notificationSlice.actions;
export default notificationSlice.reducer;
